<template>
  <div>
    <div>
      <aha-modal
        :closable="false"
        v-if="!isServerConnectable && isTokenValid"
        action-position="justify-center"
        title="Cannot connect to server"
      >
        <div>
          Please reload this page to try again.
        </div>

        <div>
          If the problem still occurs, please check your internet connection
          or contact us at
          <a href="mailto:hi@ahaslides.com">hi@ahaslides.com</a>
          for support.
        </div>

        <template #action>
          <aha-button @click="$router.go()">
            Reload
          </aha-button>
        </template>
      </aha-modal>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      remainingSeconds: null,
    }
  },
  computed: mapState({
    isServerConnectable: (state) => state.indicators.isServerConnectable,
    isTokenValid: (state) => state.isTokenValid,
  }),
}
</script>
